import type { StandardApplicability } from '@/shared/hooks/api/machineryDirectiveCompliance'
import { TypeBQuestionnaireStep } from './TypeBQuestionnaireStep'

type OnboardingTypeBQuestionnaireStepProps = {
  complianceId: string
  standards: StandardApplicability[]
  onComplete: () => void
}

export function OnboardingTypeBQuestionnaireStep({
  complianceId,
  standards,
  onComplete,
}: OnboardingTypeBQuestionnaireStepProps) {
  return (
    <TypeBQuestionnaireStep
      complianceId={complianceId}
      standards={standards}
      onComplete={onComplete}
    />
  )
}
